// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Line2px(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Line2px" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.54297 20.043L20.043 2.54297L21.4572 3.95718L3.95718 21.4572L2.54297 20.043Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Line2px.js.map